import { CommonModule } from '@angular/common';
import { Component, Output, EventEmitter, } from '@angular/core';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { ToastrService } from 'ngx-toastr';
import { Claims } from 'src/app/_models/common/claims';
import { UserRequestBase, Userrequestdto } from 'src/app/_models/user/userrequestdto';
import { ClaimsService } from 'src/app/_services/common/claims.service';
import { AuthenticationService } from "src/app/_services";
import { ConvertNonAsciiToAscii } from "src/app/common/commonvariables";
import { TextboxComponent } from '../../../shared/design-system/textbox/textbox.component';
import { ButtonComponent } from '../../../shared/design-system/button/button.component';
import { TextboxConfig } from '../../../shared/design-system/textbox/textbox.modal';
import { ButtonConfig } from '../../../shared/design-system/button/button.modal';
import { ICONS } from '../../../_helpers/icons.constants';

@Component({
    selector: 'app-create-password',
    templateUrl: './create-password.component.html',
    standalone: true,
    imports: [TranslateModule, CommonModule, TextboxComponent, ButtonComponent]
})
export class CreatePasswordComponent {

  constructor(private translate: TranslateService, 
    private authenticationService: AuthenticationService,
    private claimsService: ClaimsService,
    private toastr: ToastrService) { }

  continueConfig!: ButtonConfig;
  public param: string = "";
  newPasswordConfig!: TextboxConfig;
  confirmPasswordConfig!: TextboxConfig;
  canRegisterDisabled = false;  
  claims: Claims; 
  userrequest: UserRequestBase;
  userrequestdto: Userrequestdto;
  isConfirmPasswordError: boolean;
  emailId: string;
  password: string = '';
  confirmPassword: string = '';
  passwordCriteria1: boolean ;
  passwordCriteria2: boolean ;
  passwordCriteria3: boolean ;
  confirmPasswordError: string = '';
  public ICONS = ICONS;
    
   @Output() gotoNextStepEvent = new EventEmitter<any>();

    ngOnInit() {
      this.userrequestdto = JSON.parse(localStorage.getItem("registereduser"));
      this.newPasswordConfig = {
        id: 'new-password-input',
        label: this.translate.instant('create_password'),
        placeholder: this.translate.instant('password'),
        value: this.password,
        type: 'password',
        required: true,
        isInvalid: this.password.length>=8 && !(this.passwordCriteria1 && this.passwordCriteria2 && this.passwordCriteria3),
        isValid: this.passwordCriteria1 && this.passwordCriteria2 && this.passwordCriteria3,
        size: 'lg',
      };

      this.confirmPasswordConfig = {
        id: 'confirm-password-input',
        label: this.translate.instant('confirm_password'),
        placeholder: this.translate.instant('re_enter_password_label'),
        value: this.confirmPassword,
        type: 'password',
        helperText: this.confirmPasswordError,
        size: 'lg',
        required: true,
        isInvalid: !!this.confirmPasswordError,
        isValid: this.password === this.confirmPassword,
      };

      this.setContinueButtonConfig();
    }

  setContinueButtonConfig() {
    this.continueConfig = {
        id: 'continue-button',
        label: this.translate.instant('continue'),
        color: "primary",
        size: "lg",
        disabled: !(this.passwordCriteria1 && this.passwordCriteria2 && this.passwordCriteria3 && this.password === this.confirmPassword),
        block: true,
        ariaLabel: this.translate.instant("continue")
    };
  }

  onCreatePasswordChange(val: string) {
    this.password = val;
    this.passwordKeyPress();
    this.newPasswordConfig = {
      ...this.newPasswordConfig,
      value: val,
        isInvalid: this.password.length>=8 && !(this.passwordCriteria1 && this.passwordCriteria2 && this.passwordCriteria3),
        isValid: this.passwordCriteria1 && this.passwordCriteria2 && this.passwordCriteria3,
    };
    this.confirmPasswordConfig = {
      ...this.confirmPasswordConfig,
        isInvalid: !!this.confirmPasswordError,
        isValid: this.password === this.confirmPassword,
    };
    this.setContinueButtonConfig();
  }

  onConfirmPasswordChange(val: string) {
    this.confirmPassword = val;
    this.confirmPasswordKeyPress();
    this.confirmPasswordConfig = {
      ...this.confirmPasswordConfig,
      value: val,
        isInvalid: !!this.confirmPasswordError,
        isValid: this.password === this.confirmPassword,
    };
    this.setContinueButtonConfig();
  }
 
    registerUser() {
      if (!(this.passwordCriteria1 && this.passwordCriteria2 && this.passwordCriteria3 && this.password === this.confirmPassword)) {
        return;
      }
      this.canRegisterDisabled = true;
      this.claims = new Claims();
      this.userrequest = new UserRequestBase();
      if (this.password !== this.confirmPassword) {
          this.confirmPasswordError = this.translate.instant('password_does_not_match');
          this.isConfirmPasswordError = true;
          return;
      }
      this.userrequest.RequestInfo = new Userrequestdto();
      this.userrequest.WebApiName = "SoloRegister";
      this.userrequest.WebApiVersion = 1;
      this.userrequest.RequestId = "111";
      this.userrequestdto.Password = this.password;
      this.userrequest.RequestInfo = this.userrequestdto;
      this.authenticationService.register(this.userrequest).subscribe(
        (data: any) => {
          if (data.statusCode == 0) {
            if (localStorage.getItem("currentUser")) {
              localStorage.removeItem("currentUser");
            }
            this.claims.Token = data.responseInfo.token;
            this.claims.EmailId = data.responseInfo.emailId;
            this.claims.UserId = data.responseInfo.userId;
            this.claims.FinanceManager =
            ConvertNonAsciiToAscii.removeAccents(data.responseInfo.firstName) + " " + ConvertNonAsciiToAscii.removeAccents(data.responseInfo.lastName);
            this.claims.LoginId = data.responseInfo.emailId;
            this.claims.FMRoleType = 1;
            this.claims.isClaimOnWebAllowed =
              data.responseInfo.isClaimOnWebAllowed;
            this.claims.orgRoleId = data.responseInfo.orgRoleId;

            this.claimsService.updateClaims(this.claims);

            this.gotoNextStepEvent.emit(5);
          } else {
            this.toastr.error(data.errorInfo[0].message);
          }
        },
        (error: any) => {}
      );
    }

    passwordKeyPress() {
      this.confirmPasswordKeyPress();
      this.isConfirmPasswordError = false;
      this.passwordCriteria();
    }

    confirmPasswordKeyPress() {
      if(this.password !== this.confirmPassword && this.confirmPassword.length >= 8){
        this.confirmPasswordError = this.translate.instant('password_does_not_match');
      } else {
        this.confirmPasswordError = '';
      }
    }

    passwordCriteria(){
        this.passwordCriteria1 = false;
        this.passwordCriteria2 = false;
        this.passwordCriteria3 = false;        
        if(this.password && this.password.length >= 8) {
            this.passwordCriteria1 = true;
        }
        const hasLowerCase = /[a-z]/.test(this.password);
        const hasUpperCase = /[A-Z]/.test(this.password);
        if(hasLowerCase && hasUpperCase) {
          this.passwordCriteria2 = true;
        }
        const hasNumber = /[0-9]/.test(this.password);
        const hasSpecialChar = /[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]/.test(this.password);
        if(hasNumber || hasSpecialChar) {
          this.passwordCriteria3 = true;
        }
    }

     goToNextStep() {
      this.gotoNextStepEvent.emit(4);
    }
}